export const AdminEnpoint = ["/admin"];